import React from 'react';
import { match } from '../../Services/helpers';

const Animation = (params) => {
    return match(params.name, {
        'typing': <TypingIndicator />,
    }, null);
}

const TypingIndicator = () => {
    return <div className="typing-indicator flex flex-row items-center gap-1 p-2">
        <div className="dot dot1 bg-brand" />
        <div className="dot dot2 bg-brand" />
        <div className="dot dot3 bg-brand" />
    </div>
}

export default Animation;
